(function WebView($, Adzuki)
{
	"use strict";
	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/GroupRegistrations/view/', function onload() {
			$('.property-tab-link').click(function loadMap(e) {
				var $results_map = $(".aic-map"),
					data         = '',
					results_map  = '';

				e.preventDefault();

				if ($results_map.length > 0) {
					data        = $results_map.data('results');
					results_map = new Adzuki.Map('.aic-map', {zoom: 13});

					setTimeout(function showTheMap() {
						results_map.populate(data.map);
					}, 1100);
				}
			});

			$('.show-content').click(function showContent(e) {
				var $self = $(this),
					body  = $self.data('content') || $($self.data('modal-id')).html();

				e.preventDefault();
				$modal.find('.modal-title').text($self.text());
				$modal.find('.modal-body').html(body);
				$modal.modal('show');
			});
		});
	});

// custom functions
}(jQuery, window.Adzuki || {}));
